import axios from '@/lib/axios'
import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useDispatch } from 'react-redux'
import { clearCrispSession } from '@/lib/crisp'
import { setUser, setDriver, setMerchant, setSubcontractor, setUserRole, setDrivers, setOfflineDrivers } from '@/lib/store'
import { sortDrivers } from '@/lib/utils'
import { DISPATCH_ROLES_MAPPING, MERCHANT_ROLES_MAPPING } from '@/lib/constants';
import { ROUTES } from '@/lib/routes';

export const useAuth = ({ middleware, redirectIfAuthenticated, role } = {}) => {
    const DISPATCH_ROLES_LIST = Object.values(DISPATCH_ROLES_MAPPING);
    const MERCHANT_ROLES_LIST = Object.values(MERCHANT_ROLES_MAPPING);
    const router = useRouter()
    const dispatch = useDispatch()

    const csrf = () => axios.get('/sanctum/csrf-cookie')

    const register = async({ setErrors, submitSuccess, setIsLoadingSubmit, ...props }) => {
        setIsLoadingSubmit(true);
        await csrf()

        setErrors([])

        axios
            .post('/register', props)
            .then((json) => {
                submitSuccess();
                localStorage.setItem('access_token', json.data.access_token);
                window.location.href = redirectIfAuthenticated;
            })
            .catch(error => {
                if (error.response.status !== 422) throw error

                setErrors(Object.values(error.response.data.errors).flat())
                setIsLoadingSubmit(false);

                return false;
            })
    }

    const login = async({ setErrors, setStatus, setIsLoadingSubmit, ...props }) => {
        setIsLoadingSubmit(true);
        // await csrf()

        setErrors([])
        setStatus(null)

        axios
            .post('/api/login', props)
            .then((json) => {
                if (json.data.access_token != undefined){
                    localStorage.setItem('access_token', json.data.access_token);
                    window.location.href = redirectIfAuthenticated;
                }else{
                    if (json.data.message){
                        setErrors([json.data.message])
                    }else{
                        setErrors(['Identifiants invalides']);
                        setIsLoadingSubmit(false);
                    }
                    setIsLoadingSubmit(false);
                }
            })
            .catch(error => {
                setErrors(['Identifiants invalides']);
                setIsLoadingSubmit(false);
            })
    }

    const forgotPassword = async({ setErrors, setStatus, email }) => {
        await csrf()

        setErrors([])
        setStatus(null)

        axios
            .post('/forgot-password', { email })
            .then(response => setStatus(response.data.status))
            .catch(error => {
                if (error.response.status !== 422) throw error

                setErrors(Object.values(error.response.data.errors).flat())
            })
    }

    const resetPassword = async({ token, setErrors, setStatus, ...props }) => {
        await csrf()

        setErrors([])
        setStatus(null)

        axios
            .post('/reset-password', { token: token, ...props })
            .then(response => router.push('/login?reset=' + btoa(response.data.status)))
            .catch(error => {
                if (error.response.status !== 422) throw error

                setErrors(Object.values(error.response.data.errors).flat())
            })
    }

    const resendEmailVerification = ({ setStatus }) => {
        axios
            .post('/email/verification-notification')
            .then(response => setStatus(response.data.status))
    }

    const logout = async() => {
        await axios.post('/api/logout')
        await clearCrispSession()

        localStorage.removeItem("access_token");
        dispatch(setUser(null));
        dispatch(setMerchant({}));
        dispatch(setSubcontractor({}));
        window.location.href = '/login';
    }

    const updateDrivers = (url) =>  {
        axios
            .get(url)
            .then((response) => {

                // dispatch(setBusyDrivers(busy));
                // dispatch(setOnlineDrivers(online));

                dispatch(setOfflineDrivers(response.data.offline));
                dispatch(setDrivers(response.data.online.sort(sortDrivers)));
            })
    }

    useEffect(() => {
        axios
            .get('/api/user')
            .then((response) => {
                let user = response.data;

                let validRole = false;
                let validRoleUrl = "";
                
                if (middleware === 'guest' && redirectIfAuthenticated && user) router.push(redirectIfAuthenticated)

                if (middleware === 'auth' && !user) logout()

                if (user) {
                    if (typeof heap !== 'undefined') {
                        heap.identify(user.user.email);
                    }
                    dispatch(setUser(user.user));
                    if (user.userRole[0] == 'merchant' || MERCHANT_ROLES_LIST.includes(user.userRole[0])) {
                        dispatch(setMerchant(user.merchant));
                        dispatch(setUserRole('merchant'));

                        if (user.merchant?.has_drivers == 1) {
                            updateDrivers('/api/merchant/queue/' + user.merchant.id);
                        }

                        switch (user.userRole[0]) {
                            case 'merchant':
                                validRoleUrl = ROUTES.MERCHANT_DELIVERIES.slice(1);
                                break;
                            case 'merchant_dispatcher':
                                validRoleUrl = ROUTES.MERCHANT_DELIVERIES.slice(1);
                                break;
                            default:
                                validRoleUrl = ROUTES.MERCHANT_DELIVERIES.slice(1);
                                break;
                        }
                        validRole = "merchant";
                        
                    } else if (user.userRole[0] == 'dispatch' || DISPATCH_ROLES_LIST.includes(user.userRole[0])) {
                        dispatch(setSubcontractor(user.subcontractor));
                        dispatch(setUserRole('dispatcher'));
                        validRoleUrl = ROUTES.DISPATCH_DELIVERIES.slice(1);
                        validRole = "dispatch"
                    }else if(user.userRole[0] == 'driver'){
                        dispatch(setDriver(user.driver));
                        dispatch(setUserRole('driver'));
                        validRole = "driver";
                        validRoleUrl = ROUTES.DRIVER_DASHBOARD.slice(1);
                    }
                }
                if (role && user && validRole != role && role != 'app') router.push('/' + validRoleUrl);
            })
            .catch(error => {
                console.log(error)
                if (middleware === 'auth') router.push('/login')
            })

        
    }, [])

    return {
        register,
        login,
        forgotPassword,
        resetPassword,
        resendEmailVerification,
        logout,
    }
}